//
// Get user result
//

export const getUserResult = function() {
  let key = 'numericResult';
  let result = Cookies.get(key);

  if (result === undefined) {
    key = 'textResult';
    result = Cookies.get(key);
  }

  if (result === undefined) {
    result = 0;
  }

  return {
    'key': key,
    'result': result
  };
};

//
//  Copy share link for share widget
//

const copyShareLink = function() {
  let copyShareLinkElement = document.querySelector('.copy-share-link');

  if (copyShareLinkElement) {
    const copied = document.querySelector('.copied-tooltip');

    copyShareLinkElement.addEventListener("click", function() {
      document.getElementById('copy-share-input').select();
      document.execCommand("copy");

      copied.hidden = false;

      setTimeout(( () => copied.hidden = true), 2000);
    });

    copyShareLinkElement.addEventListener("mouseout", () => copied.hidden = true);
  }
};

//
// Toggle share footer mobile
//

const toggleShareFooter = function() {
  let shareTopBar;
  const shareFooterMobile = document.querySelectorAll(".share-footer .header .share-text, .share-footer .header .share-icon");

  if (shareFooterMobile.length) {
    for (let shareFooterItem of Array.from(shareFooterMobile)) {
      shareFooterItem.addEventListener("click", function() {
        document.querySelector(".share-footer").classList.toggle("open");
        document.querySelector(".share-footer .share-quickly").classList.toggle("open");
      });
    }
  }

  const shareButtonMobile = document.querySelector(".share-button-mobile");
  const shareButtonLastUserAnswersPage = document.querySelector(".share-button-desktop");

  if (shareButtonMobile) {
    shareButtonMobile.addEventListener("click", function() {
      document.querySelector(".share-footer").classList.toggle("open");
      document.querySelector(".share-footer .share-quickly").classList.toggle("open");

      if (!document.querySelector(".share-footer").classList.contains("visible")) {
        document.querySelector(".share-footer").classList.add("visible");
      }
    });
  }

  if (shareTopBar = document.querySelector("header.mobile .share-top-bar")) {
    shareTopBar.addEventListener("click", function(e) {
      e.preventDefault();

      if (!document.querySelector(".share-footer").classList.contains("open")) {
        document.querySelector(".share-footer").classList.toggle("open");
        document.querySelector(".share-footer .share-quickly").classList.toggle("open");
      }
    });
  }

  if (shareButtonLastUserAnswersPage) {
    shareButtonLastUserAnswersPage.addEventListener('click', function(e){
      e.preventDefault();

      document.querySelector('.share-block').classList.toggle('visible');
    });
  }
};

//
// Trigger quick share links on mobile
//

const triggerShareQuickLinks = function() {
  const shareQuicklyItems = document.querySelectorAll(".share-footer .share-quickly .share-quick-button");

  if (shareQuicklyItems) {
    Array.from(shareQuicklyItems).map((shareQuicklyItem) =>
      shareQuicklyItem.addEventListener("click", function(e) {
        let shareMethod;
        const $this = e.target.closest(".share-quick-button");

        if (shareMethod = $this.getAttribute("data-share-quick")) {
          document.querySelector(".share-footer .body a.link[data-share=" + shareMethod + "]").click();
        }
      }));
  }
};

//
// Track share buttons
//

const trackShareButtons = function() {
  const shares = document.querySelectorAll("a[data-share]");

  return Array.from(shares).map((share) =>
    share.addEventListener("click", function(event) {
      const social = event.target.closest('a[data-share]').dataset.share;
      const userResult = getUserResult();
      const dataLayerObject = {
        domain: location.hostname,
        content_token: location.pathname.split("/")[3],
      };
      dataLayerObject[social] = userResult.result;

      dataLayer.push(dataLayerObject);
    }));
};

//
//  Share bar sliding
//

const shareFooterSliding = function() {
  const shareFooter = document.querySelector(".share-footer");
  if (!shareFooter || !shareFooter.classList.contains("sliding")) { return; }

  window.onscroll = function(e) {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      if (!shareFooter.classList.contains("visible")) {
        document.querySelector(".share-footer").classList.add("visible");
      }
    } else if ((window.innerHeight + window.scrollY) < document.body.offsetHeight) {
      if (!shareFooter.classList.contains("open")) {
        document.querySelector(".share-footer").classList.remove("visible");
      }
    }
  };
};

//
// Share result
//

export function shareResult() {
  copyShareLink();
  toggleShareFooter();
  triggerShareQuickLinks();
  trackShareButtons();
  shareFooterSliding();
}